import axios from 'axios';

export default function useDatatableExport(props, pageRef, rowsRef, filtersRef, sortFieldRef, sortOrderRef) {
    function exportCSV() {
        const params = {
            format: 'excel',
            page: pageRef.value,
            rows: rowsRef.value,
            filters: filtersRef.value,
            sortField: sortFieldRef.value,
            sortOrder: sortOrderRef.value,
            userId: props.userId,
            groupId: props.groupId,
            eId: props.eId
        };
        axios.get(`/${props.resource}/${props.type}`, { params })
            .then(() => {
                console.log('Report generation started. You will be notified when ready.');
            })
            .catch(err => {
                console.error('Error exporting data:', err);
            });
    }
    return { exportCSV };
}
